module.exports = __webpack_public_path__ + "static/img/DongAnh.2862872.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DongAnh.png
// module id = v436
// module chunks = 1